import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Grid,
  FormControl,
  FormControlLabel,
  FormLabel,
  MenuItem,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import { SelectValidator } from "react-material-ui-form-validator";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import ValidatedDatePicker from "../../compartidos/ValidatedDatePicker";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import moment from "moment";
import "moment/locale/es";

import { getSectoresInternacion } from "../../../actions/autorizaciones/Autorizaciones";

const FormSolicitudDenunciaInternacion = (props) => {
  const dispatch = useDispatch();

  const { sectoresInternacion } = useSelector((state) => state.autorizaciones);

  const {
    fechaIngreso = "",
    idMotivoInternacion = "0",
    idSector = "",
  } = props.formValues;

  useEffect(() => {
    dispatch(getSectoresInternacion());
  }, [dispatch]);

  return (
    <React.Fragment>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
            <ValidatedDatePicker
              fullWidth={true}
              margin="normal"
              format="dd/MM/yyyy"
              okLabel="Aceptar"
              clearLabel="Limpiar"
              cancelLabel="Cancelar"
              label="Fecha Ingreso"
              name="fechaIngreso"
              value={
                fechaIngreso !== undefined && moment(fechaIngreso).isValid()
                  ? moment(fechaIngreso)
                  : null
              }
              onChange={(e) => {
                props.setHaveChangeValues(true);
                props.setearValor("fechaIngreso", e);
              }}
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
              maxDate={new Date()}
            />
          </MuiPickersUtilsProvider>
        </Grid>
        <Grid item xs={6}>
          {Array.isArray(sectoresInternacion) &&
            sectoresInternacion.length > 0 && (
              <SelectValidator
                fullWidth
                margin="normal"
                label="Sectores"
                name="idSector"
                value={idSector}
                onChange={(e) => {
                  props.handleInputChange(e);
                  props.setHaveChangeValues(true);
                }}
                validators={["required"]}
                errorMessages={["Este campo es requerido"]}
              >
                {sectoresInternacion.map((sector) => (
                  <MenuItem key={sector.idSector} value={sector.idSector}>
                    {sector.descripcionSector}
                  </MenuItem>
                ))}
              </SelectValidator>
            )}
        </Grid>
        <Grid item xs={12} style={{ marginTop: "1.5rem", marginLeft: "1rem" }}>
          <FormControl>
            <FormLabel>Motivo de internación:</FormLabel>
            <RadioGroup
              value={idMotivoInternacion?.toString()}
              defaultValue={idMotivoInternacion?.toString()}
              onChange={(e) => {
                props.setHaveChangeValues(true);
                props.setearValor("idMotivoInternacion", e.target.value);
              }}
            >
              <FormControlLabel
                value={"1"}
                control={<Radio />}
                label="Accidente en via pública"
              />
              <FormControlLabel
                value={"2"}
                control={<Radio />}
                label="Accidente de trabajo"
              />
              <FormControlLabel
                value={"3"}
                control={<Radio />}
                label="Otro tipo de accidente con denuncia policial"
              />
              <FormControlLabel
                value={"4"}
                control={<Radio />}
                label="Ninguno"
              />
            </RadioGroup>
          </FormControl>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default FormSolicitudDenunciaInternacion;
